/* Evora — interacciones del tema. Sin dependencias. */
(function () {
  'use strict';

  const E = window.Evora || {};
const BOFF = Number(E.bundleOff || 0); /* ahorro real del pack de 2 (igual que el descuento de Shopify) */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const TZ = 'Europe/Madrid';

  /* ------------------------------------------------------------------
     Utilidades
     ------------------------------------------------------------------ */
  function formatMoney(cents, format) {
    const fmt = format || E.money || '{{amount_with_comma_separator}} €';
    const value = Number(cents) || 0;
    const fix = (n, d, t, dec) => {
      const parts = (n / 100).toFixed(d).split('.');
      const int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts[1] ? int + dec + parts[1] : int;
    };
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = m ? m[1] : 'amount_with_comma_separator';
    let out;
    switch (key) {
      case 'amount': out = fix(value, 2, ',', '.'); break;
      case 'amount_no_decimals': out = fix(value, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': out = fix(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = fix(value, 2, "'", '.'); break;
      case 'amount_with_space_separator': out = fix(value, 2, ' ', ','); break;
      default: out = fix(value, 2, '.', ',');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '');
  }
  E.formatMoney = formatMoney;

  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.hidden = true; }, 2600);
  }

  function debounce(fn, ms) {
    let t;
    return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
  }

  /* Hora de Madrid ---------------------------------------------------- */
  function tzParts(date) {
    const f = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short', hour12: false });
    const o = {};
    f.formatToParts(date).forEach(p => { o[p.type] = p.value; });
    const wd = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[o.weekday];
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, mi: +o.minute, s: +o.second, wd };
  }
  function madridToDate(y, m, d, h, mi) {
    const guess = Date.UTC(y, m - 1, d, h, mi || 0, 0);
    const off = (t) => {
      const p = tzParts(new Date(t));
      return Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s) - t;
    };
    const first = guess - off(guess);
    return new Date(guess - off(first));
  }
  function addDaysYMD(p, n) {
    const dt = new Date(Date.UTC(p.y, p.m - 1, p.d + n));
    return { y: dt.getUTCFullYear(), m: dt.getUTCMonth() + 1, d: dt.getUTCDate(), wd: dt.getUTCDay() };
  }
  function isWorkday(p) { return p.wd !== 0 && p.wd !== 6; }
  function nextShip(cutoff) {
    const now = tzParts(new Date());
    if (isWorkday(now) && now.h < cutoff) return { day: now, today: true };
    let p = addDaysYMD(now, 1);
    while (!isWorkday(p)) p = addDaysYMD(p, 1);
    return { day: p, today: false };
  }
  function addWorkdays(p, n) {
    let q = p, c = 0;
    while (c < n) { q = addDaysYMD(q, 1); if (isWorkday(q)) c++; }
    return q;
  }
  const pad = (n) => String(n).padStart(2, '0');

  /* ------------------------------------------------------------------
     Drawers: menú, búsqueda, carrito
     ------------------------------------------------------------------ */
  const overlay = $('[data-overlay]');
  let openDrawer = null;
  let lastFocus = null;

  function open(name) {
    const el = $(`[data-drawer="${name}"]`);
    if (!el) return;
    if (openDrawer && openDrawer !== el) close();
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-open')));
    overlay && (overlay.hidden = false);
    document.body.classList.add('is-locked');
    openDrawer = el;
    $$(`[data-open="${name}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => {
      const f = $('input[type=search]', el) || el;
      f && f.focus({ preventScroll: true });
    }, 60);
  }
  function close() {
    if (!openDrawer) return;
    const el = openDrawer;
    el.classList.remove('is-open');
    overlay && (overlay.hidden = true);
    document.body.classList.remove('is-locked');
    $$('[data-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    setTimeout(() => { if (!el.classList.contains('is-open')) el.hidden = true; }, 380);
    openDrawer = null;
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  }
  E.openDrawer = open;
  E.closeDrawer = close;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const name = opener.getAttribute('data-open');
      if (name === 'cart' && document.querySelector('[data-cart-page]')) return;
      e.preventDefault();
      open(name);
      return;
    }
    if (e.target.closest('[data-close]') || e.target === overlay) close();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); closePopup(); } });

  /* Cabecera con sombra al hacer scroll */
  const hdr = $('[data-header]');
  if (hdr) {
    const setH = () => document.documentElement.style.setProperty('--hdr-h', `${hdr.offsetHeight}px`);
    setH();
    window.addEventListener('resize', debounce(setH, 100));
    const onScroll = () => hdr.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------------
     Contador de la barra superior
     ------------------------------------------------------------------ */
  class EvoraCountdown extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode || 'fixed';
      this.cutoff = parseInt(this.dataset.cutoff || '14', 10);
      this.labelA = $('[data-cd-label-a]', this);
      this.labelB = $('[data-cd-label-b]', this);
      if (this.mode === 'fixed') {
        const m = (this.dataset.end || '').match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/);
        this.target = m ? madridToDate(+m[1], +m[2], +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59) : null;
      }
      if (this.mode === 'fixed' && !this.target) {
        this.labelA && (this.labelA.hidden = true);
        this.labelB && (this.labelB.hidden = false);
        $$('[data-cd-units]', this).forEach(u => (u.hidden = true));
        return;
      }
      this.tick = this.tick.bind(this);
      this.tick();
      this.timer = setInterval(this.tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    computeDaily() {
      const ship = nextShip(this.cutoff);
      this.target = madridToDate(ship.day.y, ship.day.m, ship.day.d, this.cutoff, 0);
      this.showA = ship.today;
    }
    tick() {
      if (this.mode === 'daily') this.computeDaily();
      if (!this.target) return;
      let diff = Math.max(0, this.target.getTime() - Date.now());
      if (this.mode === 'fixed' && diff <= 0) {
        clearInterval(this.timer);
        if (this.dataset.hideAfter === 'true') { const bar = this.closest('.ann__count'); (bar || this).hidden = true; return; }
        this.labelA && (this.labelA.hidden = true);
        this.labelB && (this.labelB.hidden = false);
        $$('[data-cd-units]', this.labelB || this).forEach(u => (u.hidden = true));
        return;
      }
      if (this.mode === 'daily') {
        this.labelA && (this.labelA.hidden = !this.showA);
        this.labelB && (this.labelB.hidden = this.showA);
      }
      const d = Math.floor(diff / 864e5); diff -= d * 864e5;
      const h = Math.floor(diff / 36e5); diff -= h * 36e5;
      const mi = Math.floor(diff / 6e4); diff -= mi * 6e4;
      const s = Math.floor(diff / 1e3);
      $$('[data-cd-d]', this).forEach(el => { el.hidden = d === 0; });
      $$('[data-cd-dv]', this).forEach(el => { el.textContent = pad(d); });
      $$('[data-cd-h]', this).forEach(el => { el.textContent = pad(h); });
      $$('[data-cd-m]', this).forEach(el => { el.textContent = pad(mi); });
      $$('[data-cd-s]', this).forEach(el => { el.textContent = pad(s); });
    }
  }
  customElements.get('evora-countdown') || customElements.define('evora-countdown', EvoraCountdown);

  /* Mensajes rotativos de la barra de oferta */
  $$('[data-rotator]').forEach((rot) => {
    const msgs = $$('.ann__msg', rot);
    if (msgs.length < 2) return;
    let i = 0;
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, parseInt(rot.dataset.speed || '5000', 10));
  });

  /* ------------------------------------------------------------------
     Entrega estimada
     ------------------------------------------------------------------ */
  class EvoraDelivery extends HTMLElement {
    connectedCallback() {
      this.render = this.render.bind(this);
      this.render();
      this.timer = setInterval(this.render, 30000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    render() {
      const cfg = E.delivery || { cutoff: 14, min: 1, max: 3 };
      const ship = nextShip(cfg.cutoff);
      const from = addWorkdays(ship.day, cfg.min);
      const to = addWorkdays(ship.day, cfg.max);
      const fmt = (p) => `${E.strings.days[p.wd]} ${p.d} ${E.strings.months[p.m - 1]}`;
      const today = $('[data-dl-today]', this);
      const next = $('[data-dl-next]', this);
      if (today) today.hidden = !ship.today;
      if (next) next.hidden = ship.today;
      if (ship.today) {
        const target = madridToDate(ship.day.y, ship.day.m, ship.day.d, cfg.cutoff, 0);
        const mins = Math.max(0, Math.round((target - Date.now()) / 6e4));
        const left = $('[data-dl-left]', this);
        if (left) left.textContent = mins >= 60 ? `${Math.floor(mins / 60)} h ${mins % 60} min` : `${mins} min`;
      }
      const f = $('[data-dl-from]', this);
      const t = $('[data-dl-to]', this);
      if (f) f.textContent = fmt(from);
      if (t) t.textContent = fmt(to);
    }
  }
  customElements.get('evora-delivery') || customElements.define('evora-delivery', EvoraDelivery);

  /* ------------------------------------------------------------------
     Hero
     ------------------------------------------------------------------ */
  $$('[data-hero]').forEach((hero) => {
    const slides = $$('[data-hero-slide]', hero);
    const dots = $$('[data-hero-dot]', hero);
    if (slides.length < 2) return;
    let i = 0;
    const speed = parseInt(hero.dataset.speed || '6000', 10);
    const go = (n) => {
      slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active');
    };
    let timer = setInterval(() => go(i + 1), speed);
    dots.forEach((d, n) => d.addEventListener('click', () => { clearInterval(timer); go(n); timer = setInterval(() => go(i + 1), speed); }));
    let x0 = null;
    hero.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { clearInterval(timer); go(i + (dx < 0 ? 1 : -1)); timer = setInterval(() => go(i + 1), speed); }
      x0 = null;
    });
  });

    /* Vídeo de fondo del hero: silenciado, en bucle, inline y SIN ningún control ni icono de play.
     - La imagen de portada está debajo desde el primer momento (sin pantalla negra).
     - El vídeo solo se hace visible cuando se está reproduciendo de verdad.
     - Si el navegador bloquea el autoplay (p. ej. modo ahorro de batería) se queda la imagen limpia;
       se reintenta al cargar datos, al volver a la pestaña y con el primer gesto del usuario (permitido por los navegadores).
     - Con «reducir movimiento» no se reproduce: se queda la imagen. */
  $$('[data-hero-video]').forEach((v) => {
    const media = v.closest('.hero__media');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const showVideo = () => { if (media) { media.classList.add('is-playing'); media.classList.remove('is-static'); } };
    const showPoster = () => { if (media) { media.classList.remove('is-playing'); media.classList.add('is-static'); } };
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.controls = false;
    v.removeAttribute('controls');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.addEventListener('playing', showVideo);
    v.addEventListener('pause', () => { if (!v.ended) showPoster(); });
    const tryPlay = () => {
      if (reduce.matches || document.hidden) return;
      const p = v.play();
      if (p && typeof p.catch === 'function') p.catch(showPoster);
    };
    if (reduce.matches) {
      v.removeAttribute('autoplay');
      v.preload = 'none';
      v.pause();
      showPoster();
      return;
    }
    tryPlay();
    v.addEventListener('canplay', () => { if (v.paused) tryPlay(); }, { once: true });
    document.addEventListener('visibilitychange', () => { if (!document.hidden && v.paused) tryPlay(); });
    const onFirstGesture = () => { if (v.paused) tryPlay(); };
    ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach((ev) => window.addEventListener(ev, onFirstGesture, { once: true, passive: true }));
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { if (en.isIntersecting) { if (v.paused) tryPlay(); } else if (!v.paused) v.pause(); }, { threshold: 0.1 }).observe(v);
    }
  });

  /* ------------------------------------------------------------------
     Sliders
     ------------------------------------------------------------------ */
  function initSliders(root = document) {
    $$('[data-slider]', root).forEach((slider) => {
      if (slider._init) return;
      slider._init = true;
      const track = $('[data-slider-track]', slider);
      if (!track) return;
      const section = slider.closest('section') || slider.parentElement;
      const prev = $('[data-slide-prev]', section);
      const next = $('[data-slide-next]', section);
      const bar = $('[data-slider-bar]', slider);
      const step = () => {
        const first = track.children[0];
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return first ? first.getBoundingClientRect().width + gap : track.clientWidth;
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        if (bar) {
          bar.parentElement.hidden = max <= 2;
          const vis = Math.min(1, track.clientWidth / Math.max(1, track.scrollWidth));
          bar.style.width = `${vis * 100}%`;
          bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0}%)`;
        }
      };
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', debounce(update, 30), { passive: true });
      window.addEventListener('resize', debounce(update, 100));
      update();
    });
  }
  initSliders();
  E.initSliders = initSliders;
  document.addEventListener('shopify:section:load', (e) => initSliders(e.target));

  /* ------------------------------------------------------------------
     Aparición suave al hacer scroll
     ------------------------------------------------------------------ */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.remove('is-pending'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el, n) => {
      if (el.getBoundingClientRect().top > window.innerHeight) {
        el.classList.add('is-pending');
        el.style.transitionDelay = `${(n % 4) * 70}ms`;
        io.observe(el);
      }
    });
  }

  /* ------------------------------------------------------------------
     Carrito
     ------------------------------------------------------------------ */
  const CART_SECTION = 'cart-drawer';

  function renderCart(sections, cartCount) {
    const html = sections && sections[CART_SECTION];
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nb = $('[data-cart-body]', doc);
      const nf = $('[data-cart-foot]', doc);
      const nc = $('[data-cart-count-inline]', doc);
      const drawer = $('#CartDrawer');
      if (drawer) {
        const body = $('[data-cart-body]', drawer);
        const foot = $('[data-cart-foot]', drawer);
        const openIds = foot ? $$('details[open][id]', foot).map((d) => d.id) : [];
        if (body && nb) body.innerHTML = nb.innerHTML;
        if (foot && nf) { foot.innerHTML = nf.innerHTML; foot.hidden = nf.hasAttribute('hidden'); openIds.forEach((id) => { const d = document.getElementById(id); if (d) d.open = true; }); }
        const ci = $('[data-cart-count-inline]', drawer);
        if (ci && nc) ci.textContent = nc.textContent;
      }
    }
    if (typeof cartCount === 'number') {
      $$('[data-cart-count]').forEach((b) => { b.textContent = cartCount; b.hidden = cartCount === 0; });
    }
  document.dispatchEvent(new CustomEvent('evora:cart:rendered', { detail: { count: cartCount } }));
  }
  E.renderCart = renderCart;

  async function refreshCount() {
    try {
      const res = await fetch(`${E.routes.cart}.js`, { headers: { Accept: 'application/json' } });
      const c = await res.json();
      renderCart(null, c.item_count);
      return c;
    } catch (e) { return null; }
  }

  function addItems(items, opts = {}) { return serial(() => addItemsNow(items, opts)); }
async function addItemsNow(items, opts = {}) {
    const res = await fetch(`${E.routes.cartAdd}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: [CART_SECTION], sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || E.strings.error);
    const cart = await refreshCount();
    renderCart(data.sections && data.sections[CART_SECTION] ? data.sections : await fetchCartSections(), cart ? cart.item_count : undefined);
    if (document.querySelector('[data-cart-page]')) { window.location.reload(); return data; }
    if (!opts.silent) open('cart');
    return data;
  }
  E.addItems = addItems;

  /* Cola única para todas las operaciones del carrito (añadir, cantidades, quitar):
   evita carreras, respuestas fuera de orden y renders con datos viejos. */
let cartChain = Promise.resolve();
let cartJobs = 0;
function setCartBusy(on) {
  const d = $('#CartDrawer');
  if (!d) return;
  d.classList.toggle('is-busy', on);
  d.setAttribute('aria-busy', on ? 'true' : 'false');
}
function serial(task) {
  cartJobs += 1;
  setCartBusy(true);
  const run = cartChain.then(task, task);
  cartChain = run.catch(() => {}).then(() => {
    cartJobs = Math.max(0, cartJobs - 1);
    if (!cartJobs) setCartBusy(false);
  });
  return run;
}
E.cartSerial = serial;

async function fetchCartSections() {
  try {
    const r = await fetch(window.location.pathname + '?sections=' + CART_SECTION, { headers: { Accept: 'application/json' } });
    return await r.json();
  } catch (e) { return null; }
}
async function resyncCart() {
  const results = await Promise.all([fetchCartSections(), refreshCount()]);
  renderCart(results[0], results[1] ? results[1].item_count : undefined);
}
E.resyncCart = resyncCart;

async function changeQty(target, quantity) {
  const payload = { quantity, sections: [CART_SECTION], sections_url: window.location.pathname };
  if (target.key) payload.id = target.key; else payload.line = target.line;
  const res = await fetch(E.routes.cartChange + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload)
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.status) throw new Error(data.description || data.message || E.strings.error);
  if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
  const sections = data.sections && data.sections[CART_SECTION] ? data.sections : await fetchCartSections();
  renderCart(sections, data.item_count);
}

/* Cantidad deseada por línea (clave de Shopify). Varios clics seguidos se agrupan en una sola petición. */
const pendingQty = new Map();
function requestQty(ctl, quantity) {
  const lineEl = ctl.closest('[data-key]');
  const target = lineEl ? { key: lineEl.dataset.key } : { line: parseInt(ctl.dataset.lineQty || ctl.dataset.lineInput, 10) };
  if (!target.key && !target.line) return;
  const id = target.key || ('line:' + target.line);
  const qty = Math.max(0, parseInt(quantity, 10) || 0);
  const inp = lineEl ? $('[data-line-input]', lineEl) : null;
  if (inp) inp.value = qty;
  if (lineEl) lineEl.classList.toggle('is-removing', qty === 0);
  const alreadyQueued = pendingQty.has(id);
  pendingQty.set(id, { target, qty });
  if (alreadyQueued) return;
  serial(async () => {
    const p = pendingQty.get(id);
    pendingQty.delete(id);
    if (p) await changeQty(p.target, p.qty);
  }).catch(async (err) => {
    toast(err.message || E.strings.error);
    await resyncCart();
  });
}

document.addEventListener('click', async (e) => {
  const lq = e.target.closest('[data-line-qty]');
  if (lq) {
    e.preventDefault();
    const lineEl = lq.closest('[data-key]');
    const inp = lineEl ? $('[data-line-input]', lineEl) : null;
    let qty = parseInt(lq.dataset.qtyValue, 10);
    if (inp && lq.hasAttribute('data-qty-step')) qty = (parseInt(inp.value, 10) || 0) + Number(lq.dataset.qtyStep);
    requestQty(lq, qty);
    return;
  }
  const qa = e.target.closest('[data-quick-add]');
  const ai = e.target.closest('[data-add-items]');
  const btn = qa || ai;
  if (!btn) return;
  e.preventDefault();
  if (btn.classList.contains('is-loading')) return;
  const ids = qa ? [qa.dataset.quickAdd] : ai.dataset.addItems.split(',');
  btn.classList.add('is-loading');
  try {
    await addItems(ids.filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 })), { silent: false });
  } catch (err) {
    toast(err.message || E.strings.error);
  } finally {
    btn.classList.remove('is-loading');
  }
});

document.addEventListener('change', (e) => {
  const inp = e.target.closest('[data-line-input]');
  if (inp) requestQty(inp, inp.value);
});

const saveNote = debounce(async (value) => {
    try {
      await fetch(`${E.routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: value }) });
    } catch (e) { /* sin conexión: se reintenta al escribir */ }
  }, 500);
  document.addEventListener('input', (e) => {
    const n = e.target.closest('[data-cart-note]');
    if (n) saveNote(n.value);
  });

  /* ------------------------------------------------------------------
     Ficha de producto
     ------------------------------------------------------------------ */
  const initProduct = (root) => {
    if (root._evoraInit) return;
    root._evoraInit = true;
    const section = root.closest('.shopify-section') || document;
    const jsonEl = $('[data-product-json]', section);
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const form = $('form[data-type="add-to-cart-form"]', root);
    const idInput = form ? $('[data-variant-input]', form) : null;
    let variant = product && idInput ? product.variants.find((v) => v.id === Number(idInput.value)) : null;

    /* Galería filtrada por acabado.
       Las fotos anteriores a la primera foto asignada a una variante son comunes y se ven siempre.
       Cada variante muestra su foto y las siguientes, hasta la foto de la próxima variante.
       Si la variante elegida no tiene fotos propias, se ven todas y se avisa de qué acabado muestran. */
    const track = $('[data-gallery-track]', root);
    const thumbs = $$('[data-thumb]', root);
    const dots = $$('.pdp__dots span', root);
    const slides = track ? Array.from(track.children) : [];
    const mediaNote = $('[data-media-note]', root);
    const vMedia = product ? product.variants.map((v) => Number(v.media_id) || 0).filter(Boolean) : [];
    const isVSlide = (s) => vMedia.indexOf(Number(s.dataset.mediaId)) > -1;
    const firstV = slides.findIndex(isVSlide);
    let visible = slides.map((_, i) => i);
    const cur = () => (track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0);
    const goSlide = (n, smooth = true) => { if (track) track.scrollTo({ left: n * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' }); };
    const syncGallery = () => {
      const n = cur();
      thumbs.forEach((t) => {
        const pos = visible.indexOf(Number(t.dataset.thumb));
        t.style.display = pos < 0 ? 'none' : '';
        t.classList.toggle('is-active', pos === n);
        t.setAttribute('aria-label', `${pos + 1} / ${visible.length}`);
      });
      dots.forEach((d, i) => {
        const pos = visible.indexOf(i);
        d.style.display = pos < 0 ? 'none' : '';
        d.classList.toggle('is-active', pos === n);
      });
      visible.forEach((i, k) => {
        const vid = $('video', slides[i]);
        if (vid) { if (k === n) vid.play().catch(() => {}); else vid.pause(); }
      });
    };
    const groupFor = (v) => {
      if (!v || !v.media_id || firstV < 0) return null;
      const start = slides.findIndex((s) => Number(s.dataset.mediaId) === Number(v.media_id));
      if (start < 0) return null;
      const out = [];
      for (let i = 0; i < firstV; i++) out.push(i);
      for (let j = start; j < slides.length; j++) { if (j > start && isVSlide(slides[j])) break; out.push(j); }
      return out;
    };
    const applyGallery = (v) => {
      if (!track || !slides.length) return;
      const g = groupFor(v);
      visible = g || slides.map((_, i) => i);
      slides.forEach((s, i) => { s.style.display = visible.indexOf(i) > -1 ? '' : 'none'; });
      const many = visible.length > 1;
      const arrows = $('.pdp__arrows', root);
      if (arrows) arrows.style.display = many ? '' : 'none';
      const dotWrap = $('.pdp__dots', root);
      if (dotWrap) dotWrap.style.visibility = many ? '' : 'hidden';
      if (mediaNote) {
        const owners = product ? product.variants.filter((x) => x.media_id && (!v || x.id !== v.id)) : [];
        const show = !g && !!v && !v.media_id && vMedia.length > 0 && owners.length > 0;
        mediaNote.hidden = !show;
        if (show) {
          const names = Array.from(new Set(owners.map((x) => String(x.title).toLowerCase()))).join(' / ');
          mediaNote.textContent = (E.strings.mediaNote || 'Las fotos muestran el acabado [x].').replace('[x]', names);
        }
      }
      const target = g ? Math.max(0, visible.findIndex((i) => Number(slides[i].dataset.mediaId) === Number(v.media_id))) : 0;
      goSlide(target, false);
      syncGallery();
    };
    if (track) {
      track.addEventListener('scroll', debounce(syncGallery, 60), { passive: true });
      thumbs.forEach((t) => t.addEventListener('click', () => { const pos = visible.indexOf(Number(t.dataset.thumb)); if (pos > -1) goSlide(pos); }));
      const prevB = $('[data-gallery-prev]', root);
      const nextB = $('[data-gallery-next]', root);
      prevB && prevB.addEventListener('click', () => goSlide(Math.max(0, cur() - 1)));
      nextB && nextB.addEventListener('click', () => goSlide(Math.min(visible.length - 1, cur() + 1)));
      window.addEventListener('resize', debounce(() => goSlide(cur(), false), 150));
    }

    /* Packs (oferta pack de 2) */
    const packs = $('[data-packs]', root);
    const mix = packs ? $('[data-pack-mix]', packs) : null;
    const qtyInput = $('[data-qty-input]', root);
    const getPack = () => {
      const c = packs && $('input[type=radio]:checked', packs);
      return c ? Number(c.value) : 0;
    };
    const unitPrice = () => (variant ? variant.price : Number(packs && packs.dataset.unit) || 0);
    const payFor = (pack) => {
      const u = unitPrice();
      if (pack === 1) return { pay: u, full: u, n: 1 };
      if (pack === 2) {
        const opt = mix && mix.value !== 'same' ? mix.selectedOptions[0] : null;
        const p2 = opt ? Number(opt.dataset.price) : u;
        return { pay: u + p2 - Math.min(BOFF, u, p2), full: u + p2, n: 2 };
      }
      if (pack === 4) return { pay: u * 4 - Math.min(BOFF, u), full: u * 4, n: 4 }; /* 1 pack por pedido */
      const q = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      return { pay: u * q, full: u * q, n: q };
    };
    const atcPrice = $('[data-atc-price]', root);
    const atcLabelEl = $('[data-atc-label]', root);
    const stickyPrice = $('[data-sticky-price]', section);
    const stickyPack = $('[data-sticky-pack]', section);
    const offerLine = $('[data-offer-line-text]', root);
    const shipMin = Number(E.freeShippingThreshold || 0);
    const renderPrices = () => {
      if (packs) {
        $$('[data-pack]', packs).forEach((el) => {
          const n = Number(el.dataset.pack);
          const r = payFor(n);
          const pay = $('[data-pack-pay]', el);
          const full = $('[data-pack-full]', el);
          const save = $('[data-pack-save]', el);
          const unitEl = $('[data-pack-unit]', el);
          const ship = $('[data-pack-ship]', el);
          if (pay) pay.textContent = formatMoney(r.pay);
          if (full) full.textContent = formatMoney(r.full);
          if (save) save.textContent = `-${Math.round(((r.full - r.pay) / Math.max(1, r.full)) * 100)} %`;
          if (unitEl) unitEl.textContent = `${formatMoney(Math.round(r.pay / r.n))}${E.strings.perUnit || '/ud.'}`;
          if (ship) ship.hidden = !(shipMin > 0 && r.pay >= shipMin);
          const saveAmt = $('[data-pack-saveamt]', el);
          if (saveAmt) { saveAmt.hidden = r.full <= r.pay; saveAmt.textContent = (E.strings.youSave || 'Ahorras [amount]').replace('[amount]', formatMoney(r.full - r.pay)); }
          el.classList.toggle('is-selected', $('input', el).checked);
        });
      }
      const sel = getPack();
      const r = payFor(sel);
      if (atcPrice) atcPrice.textContent = formatMoney(r.pay);
      if (stickyPrice) stickyPrice.textContent = formatMoney(r.pay);
      if (atcLabelEl && variant && variant.available) {
        atcLabelEl.textContent = r.n > 1 ? (E.strings.addN || 'Añadir [n] al carrito').replace('[n]', r.n) : E.strings.addToCart;
      }
      if (stickyPack) {
        const lab = packs && $(`[data-pack="${sel}"] .pack__title`, packs);
        stickyPack.textContent = lab ? lab.textContent.trim() : '';
      }
      if (offerLine && E.strings.offerPdp && variant) {
        offerLine.innerHTML = E.strings.offerPdp.replace('[price2]', formatMoney(variant.price * 2 - Math.min(BOFF, variant.price))).replace('[unit]', formatMoney(Math.round((variant.price * 2 - Math.min(BOFF, variant.price)) / 2)));
      }
    };
    packs && packs.addEventListener('change', renderPrices);
    if (qtyInput) {
      const qwrap = qtyInput.closest('[data-qty]');
      $('[data-qty-minus]', qwrap).addEventListener('click', () => { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); renderPrices(); });
      $('[data-qty-plus]', qwrap).addEventListener('click', () => { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; renderPrices(); });
      qtyInput.addEventListener('change', renderPrices);
    }

    /* Variantes */
    const picker = $('[data-variant-picker]', root);
    const priceEl = $('[data-price]', root);
    const atc = $('[data-atc]', root);
    const atcLabel = $('[data-atc-label]', root);
    const stickyBtn = $('[data-sticky-btn]', section);
    const stockWrap = $('[data-stock-wrap]', root);
    const renderStock = (v) => {
      if (!stockWrap || !v) return;
      const thr = Number(($('[data-stock]', stockWrap) || {}).dataset?.threshold || 5);
      let state = 'in', text = E.strings.inStock;
      if (!v.available) { state = 'out'; text = E.strings.soldOut; }
      else if (v.tracked && v.qty > 0 && v.qty <= thr) { state = 'low'; text = E.strings.lowStock.replace('[count]', v.qty); }
      const pct = state === 'low' ? Math.max(12, Math.round((v.qty / thr) * 100)) : 100;
      stockWrap.innerHTML = `<div class="stock stock--${state}" data-stock data-threshold="${thr}"><span class="stock__dot" aria-hidden="true"></span><span class="stock__text">${text}</span>${state === 'low' ? `<span class="stock__bar" aria-hidden="true"><span style="width:${pct}%"></span></span>` : ''}</div>`;
    };
    const onVariant = (v) => {
      variant = v;
      if (!v) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = E.strings.unavailable || E.strings.soldOut;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        const sale = v.compare_at_price > v.price;
        priceEl.className = `price${sale ? ' price--sale' : ''}`;
        priceEl.innerHTML = `<span class="price__current">${formatMoney(v.price)}</span>${sale ? `<s class="price__compare">${formatMoney(v.compare_at_price)}</s><span class="price__save">-${Math.round((1 - v.price / v.compare_at_price) * 100)}%</span>` : ''}`;
      }
      if (atc) atc.disabled = !v.available;
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? E.strings.addToCart : E.strings.soldOut;
      renderStock(v);
      renderPrices();
      applyGallery(v);
      if (mix) {
        const same = $('[data-same]', mix);
        if (same) { same.dataset.price = v.price; same.textContent = (E.strings.packSame || 'Otra igual') + (product && product.variants.length > 1 ? ' · ' + v.title : ''); }
        $$('option', mix).forEach((o) => { if (!o.hasAttribute('data-same')) o.hidden = Number(o.value) === v.id; });
        if (mix.value !== 'same' && Number(mix.value) === v.id) mix.value = 'same';
      }
      if (!root.hasAttribute('data-no-url')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      const bn = $('[data-buy-now]', root);
      if (bn) bn.disabled = !v.available;
    };
    if (picker && product) {
      picker.addEventListener('change', (e) => {
        const selected = [];
        $$('fieldset', picker).forEach((fs, k) => {
          const c = $('input:checked', fs);
          selected[k] = c ? c.value : null;
          const label = $(`[data-option-value="${k}"]`, picker);
          if (label && c) label.textContent = c.value;
        });
        onVariant(product.variants.find((v) => v.options.every((o, k) => o === selected[k])));
      });
    }

    /* Añadir al carrito */
    if (form) {
      const buildItems = () => {
        const pack = getPack();
        if (pack === 2) {
          return mix && mix.value !== 'same'
            ? [{ id: variant.id, quantity: 1 }, { id: Number(mix.value), quantity: 1 }]
            : [{ id: variant.id, quantity: 2 }];
        }
        if (pack === 4) return [{ id: variant.id, quantity: 4 }];
        if (pack === 1) return [{ id: variant.id, quantity: 1 }];
        const gcItem = { id: variant.id, quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1 };
        /* Tarjeta regalo: enviar a otra persona (propiedades nativas de Shopify) */
        const gcBox = $('[data-gc-recipient]', form);
        const gcToggle = gcBox && $('[data-gc-toggle]', gcBox);
        if (gcToggle && gcToggle.checked) {
          const gp = { __shopify_send_gift_card_to_recipient: 'true', __shopify_offset: String(new Date().getTimezoneOffset()) };
          $$('[data-gc-prop]', gcBox).forEach((el) => { const val = el.value.trim(); if (val) gp[el.dataset.gcProp] = val; });
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(gp['Recipient email'] || '')) {
            const em = $('[data-gc-prop="Recipient email"]', gcBox);
            if (em) em.focus();
            throw new Error('Escribe un email válido para la persona que recibe la tarjeta.');
          }
          gcItem.properties = gp;
        }
        return [gcItem];
      };
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!variant) return;
        const buttons = [atc, stickyBtn].filter(Boolean);
        buttons.forEach((b) => b.classList.add('is-loading'));
        try {
          await addItems(buildItems());
        } catch (err) {
          toast(err.message || E.strings.error);
        } finally {
          buttons.forEach((b) => b.classList.remove('is-loading'));
        }
      });
      const buyNow = $('[data-buy-now]', root);
      if (buyNow) {
        buyNow.addEventListener('click', async () => {
          if (!variant || !variant.available) return;
          buyNow.classList.add('is-loading');
          try {
            await addItems(buildItems(), { silent: true });
            window.location.href = `${E.routes.root.replace(/\/$/, '')}/checkout`;
          } catch (err) {
            toast(err.message || E.strings.error);
            buyNow.classList.remove('is-loading');
          }
        });
      }
    }

    /* Barra fija de compra */
    const sticky = $('[data-sticky-atc]', section);
    if (sticky && atc && 'IntersectionObserver' in window) {
      const footer = $('.ftr');
      let atcOut = false, footerIn = false;
      const upd = () => {
        const show = atcOut && !footerIn;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      };
      /* Móvil: la barra se ve siempre que el botón principal no esté en pantalla (también antes de llegar a él). */
      const mqMobile = window.matchMedia('(max-width: 989px)');
      new IntersectionObserver(([en]) => { atcOut = !en.isIntersecting && (mqMobile.matches || en.boundingClientRect.top < 0); upd(); }).observe(atc);
      footer && new IntersectionObserver(([en]) => { footerIn = en.isIntersecting; upd(); }).observe(footer);
    }

    const stickyChange = $('[data-sticky-change]', section);
    if (stickyChange && packs) stickyChange.addEventListener('click', () => packs.scrollIntoView({ behavior: 'smooth', block: 'center' }));
    

    applyGallery(variant);
    renderPrices();
  };
  $$('[data-product]').forEach(initProduct);
  document.addEventListener('shopify:section:load', (e) => $$('[data-product]', e.target).forEach(initProduct));

  /* Recomendaciones de producto */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length && $('.slider', el)) return;
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initSliders(el); }
    } catch (e) { /* sin recomendaciones */ }
  });

  /* ------------------------------------------------------------------
     Vídeos UGC
     ------------------------------------------------------------------ */
  /* La lógica de vídeos UGC vive en sections/ugc-videos.liquid (evita listeners duplicados). */

  /* ------------------------------------------------------------------
     Búsqueda predictiva
     ------------------------------------------------------------------ */
  const psInput = $('[data-predictive-input]');
  const psResults = $('[data-predictive-results]');
  if (psInput && psResults) {
    const initial = psResults.innerHTML;
    const run = debounce(async () => {
      const q = psInput.value.trim();
      if (q.length < 2) { psResults.innerHTML = initial; return; }
      try {
        const url = `${E.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
        const res = await fetch(url);
        const data = await res.json();
        const items = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!items.length) {
          psResults.innerHTML = `<p class="muted">No hay resultados para “${q.replace(/[<>&"]/g, '')}”.</p>`;
          return;
        }
        const esc = (s) => String(s || '').replace(/[<>&"]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]));
        psResults.innerHTML = `<div class="ps-results__grid">${items.map((p) => {
          const img = (p.featured_image && p.featured_image.url) || p.image || '';
          const price = p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
          return `<a class="ps-item" href="${esc(p.url)}">${img ? `<img src="${esc(img)}${img.includes('?') ? '&' : '?'}width=400" alt="${esc(p.title)}" loading="lazy" width="400" height="400">` : ''}<span>${esc(p.title)}</span><span class="ps-item__price">${esc(price)}</span></a>`;
        }).join('')}</div><a class="link-arrow" href="${E.routes.search}?q=${encodeURIComponent(q)}&type=product">Ver todos los resultados</a>`;
      } catch (e) { /* mantener resultados anteriores */ }
    }, 220);
    psInput.addEventListener('input', run);
  }

  /* ------------------------------------------------------------------
     Pop-up de bienvenida
     ------------------------------------------------------------------ */
  const popup = $('[data-popup]');
  function closePopup() {
    if (!popup || popup.hidden) return;
    popup.hidden = true;
    document.body.classList.remove('is-locked');
    try {
      const days = Number(popup.dataset.days || 7);
      localStorage.setItem('evoraPopupUntil', String(Date.now() + days * 864e5));
    } catch (e) { /* almacenamiento no disponible */ }
  }
  if (popup) {
    const showPopup = () => { popup.hidden = false; document.body.classList.add('is-locked'); };
    let until = 0;
    try { until = Number(localStorage.getItem('evoraPopupUntil') || 0); } catch (e) { until = 0; }
    const posted = window.location.hash === '#PopupForm' && /customer_posted=true/.test(window.location.search);
    if (posted) showPopup();
    else if (Date.now() > until && !document.querySelector('[data-cart-page]') && !/\/(checkouts|account)/.test(window.location.pathname)) {
      setTimeout(() => { if (!openDrawer) showPopup(); }, Number(popup.dataset.delay || 12000));
    }
    $$('[data-popup-close]', popup).forEach((b) => b.addEventListener('click', closePopup));
  }

  /* ------------------------------------------------------------------
     Toggles (formulario de reseñas, etc.)
     ------------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-toggle]');
    if (!t) return;
    const sel = t.dataset.toggle;
    const target = $(sel);
    if (!target) return;
    const on = !target.classList.contains('is-open');
    target.classList.toggle('is-open', on);
    $$(`[data-toggle="${sel}"]`).forEach((b) => b.hasAttribute('aria-expanded') && b.setAttribute('aria-expanded', on ? 'true' : 'false'));
    if (on) { const f = $('input,textarea', target); f && f.focus({ preventScroll: false }); }
  });

  /* ------------------------------------------------------------------
     Vídeo en ventana (hero)
     ------------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-video-open]');
    if (o) {
      const d = document.getElementById(o.dataset.videoOpen);
      if (d && d.showModal) { d.showModal(); const v = $('video', d); v && v.play().catch(() => {}); }
      return;
    }
    const d = e.target.closest('[data-video-modal]');
    if (d && (e.target.closest('[data-video-close]') || e.target === d)) {
      const v = $('video', d); v && v.pause();
      d.close();
    }
  });

  /* ------------------------------------------------------------------
     Crea tu combinación
     ------------------------------------------------------------------ */
  $$('[data-combo]').forEach((box) => {
    const bogo = box.dataset.bogo === 'true';
    let size = Number(box.dataset.size || 2);
    const picks = new Map();
    const countEl = $('[data-combo-count]', box);
    const maxEl = $('[data-combo-max]', box);
    const payEl = $('[data-combo-pay]', box);
    const fullEl = $('[data-combo-full]', box);
    const addBtn = $('[data-combo-add]', box);
    const total = () => Array.from(picks.values()).reduce((a, p) => a + p.qty, 0);
    const render = () => {
      const n = total();
      if (countEl) countEl.textContent = n;
      if (maxEl) maxEl.textContent = size;
      const prices = [];
      picks.forEach((p) => { for (let k = 0; k < p.qty; k++) prices.push(p.price); });
      prices.sort((a, b) => b - a);
      const full = prices.reduce((a, b) => a + b, 0);
      const pay = bogo && prices.length > 1 ? full - Math.min(BOFF, prices[prices.length - 1]) : full; /* pack: ahorro real 1 vez por pedido sobre la más barata */
      if (payEl) payEl.textContent = formatMoney(pay);
      if (fullEl) { fullEl.textContent = formatMoney(full); fullEl.hidden = !(pay < full); }
      if (addBtn) addBtn.disabled = n !== size;
      $$('[data-combo-item]', box).forEach((b) => {
        const p = picks.get(b.dataset.comboItem);
        const q = p ? p.qty : 0;
        b.classList.toggle('is-picked', q > 0);
        b.setAttribute('aria-pressed', q > 0 ? 'true' : 'false');
        const badge = $('[data-combo-qty]', b);
        if (badge) { badge.hidden = q === 0; badge.textContent = `×${q}`; }
        const minus = $(`[data-combo-minus="${b.dataset.comboItem}"]`, box);
        if (minus) minus.hidden = q === 0;
        b.disabled = q === 0 && n >= size;
      });
    };
    $$('[data-combo-size]', box).forEach((b) => b.addEventListener('click', () => {
      size = Number(b.dataset.comboSize);
      $$('[data-combo-size]', box).forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      let over = total() - size;
      Array.from(picks.keys()).reverse().forEach((k) => {
        while (over > 0 && picks.get(k) && picks.get(k).qty > 0) { picks.get(k).qty -= 1; over -= 1; if (picks.get(k).qty === 0) picks.delete(k); }
      });
      render();
    }));
    $$('[data-combo-item]', box).forEach((b) => b.addEventListener('click', () => {
      if (total() >= size) return;
      const id = b.dataset.comboItem;
      const p = picks.get(id) || { qty: 0, price: Number(b.dataset.price) };
      p.qty += 1;
      picks.set(id, p);
      render();
    }));
    $$('[data-combo-minus]', box).forEach((b) => b.addEventListener('click', () => {
      const p = picks.get(b.dataset.comboMinus);
      if (!p) return;
      p.qty -= 1;
      if (p.qty <= 0) picks.delete(b.dataset.comboMinus);
      render();
    }));
    addBtn && addBtn.addEventListener('click', async () => {
      if (total() !== size) return;
      addBtn.classList.add('is-loading');
      try {
        await addItems(Array.from(picks.entries()).map(([id, p]) => ({ id: Number(id), quantity: p.qty })));
        picks.clear();
        render();
      } catch (err) {
        toast(err.message || E.strings.error);
      } finally {
        addBtn.classList.remove('is-loading');
      }
    });
    render();
  });

  /* Ordenar colección */
  $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }));

  /* ------------------------------------------------------------------
     404: redirección a la tienda
     ------------------------------------------------------------------ */
  const redir = $('[data-redirect]');
  if (redir) {
    let left = Number(redir.dataset.seconds || 8);
    const out = $('[data-redirect-count]', redir);
    let cancelled = false;
    const cancel = () => { cancelled = true; redir.hidden = true; };
    ['keydown', 'touchstart', 'wheel'].forEach((ev) => window.addEventListener(ev, cancel, { once: true, passive: true }));
    $$('input', document).forEach((i) => i.addEventListener('focus', cancel, { once: true }));
    const iv = setInterval(() => {
      if (cancelled) { clearInterval(iv); return; }
      left -= 1;
      if (out) out.textContent = left;
      if (left <= 0) { clearInterval(iv); window.location.href = redir.dataset.url; }
    }, 1000);
  }
})();
